module.exports = __webpack_public_path__ + "img/minimize.0e066b43.svg";